// src/en/index.ts
var en = {
  // onboarding
  inviteTeamMembersTo: "Invite team members to your workspace",
  loggingIn: "Logging you in",
  defaultSpaceName: "General",
  onboardingSpaceName: "Welcome 👋",
  loginCodeSendAgain: "Send your login code again",
  loginCodeResent: "Your login code has been sent again.",
  loginCodeError: "Wrong login verification code.",
  loginCodeErrorSending: "There was a problem sending your login verification code.",
  loginCodeErrorExpired: "Your login verification has expired, we’ve sent you another one.",
  loginCodeErrorRateLimited: "You’ve made too many attempts, please try again later.",
  pickAWorkspaceName: "Pick a workspace name",
  creatingWorkspace: "Creating workspace",
  createaSpace: "Create a space",
  subdomainExists: "This workspace name is already taken. Please try another.",
  emailLabel: "Your email address",
  passwordLabel: "Password",
  checkEmail: "Check your email",
  haveSent: "We’ve sent a ",
  weSentALoginCode: "We sent a login code to:",
  sixDigit: "6 digit login code",
  sixDigits: "6 digits",
  confTo: "to",
  checkInbox: "Please check your inbox.",
  teamName: "What’s the name of your team?",
  workspaceNameLabel: "Workspace name",
  workspaceNamePlaceHolder: "e.g. Acme industries",
  spaceNameLabel: "Space name",
  spaceNamePlaceHolder: "e.g. web-shop",
  min3Characters: "Minimum 3 characters long.",
  continueWithProvider: "Continue with %{provider}",
  welcomeToSuperThread: "Welcome to Superthread",
  aWorkspaceIs: "A workspace is usually named after your organisation. You cannot change this name later.",
  youCanChangeThis: "You can change this later and create as many spaces as you like.",
  LoginCode: "Login code",
  enterLoginCode: "Enter login code",
  continueWithEmail: "Continue with Email",
  registerProvider: "Register with %{provider}",
  onboardingEmailPlaceholder: "you@example.com",
  // cards
  cardsLayoutList: "List",
  cardsLayoutBoard: "Board",
  cardsLayoutTimeline: "Timeline",
  cardsLayoutCalendar: "Calendar (Beta)",
  // Group titles
  ["slash.group.media"]: "Media",
  ["slash.group.basic"]: "Basic",
  ["slash.group.inline"]: "Inline",
  ["slash.group.embed"]: "Embed",
  // Keywords
  ["slash.keyword.media"]: "attach,image,file,upload,media,attachment",
  // Commands
  // slashCommands
  ["slash.display.attach"]: "Attach",
  ["slash.search.attach"]: "attach",
  "slash.display.image": "Image",
  "slash.display.youtube": "Embed YouTube video",
  "slash.display.checklist": "Checklist",
  "slash.display.table": "Table",
  "slash.display.h1": "H1",
  "slash.display.h2": "H2",
  "slash.display.h3": "H3",
  "slash.display.bulleted": "Bulleted list",
  "slash.display.numbered": "Numbered list",
  "slash.display.blockquote": "Blockquote",
  "slash.display.hr": "Horizontal rule",
  "slash.display.card": "Card",
  "slash.display.mention": "Mention",
  "slash.display.codeBlock": "Code block",
  "slash.display.board": "Board",
  "slash.display.callout": "Callout",
  "slash.search.image": "image",
  "slash.search.youtube": "youtube video",
  "slash.search.checklist": "checklist",
  "slash.search.table": "table",
  "slash.search.h1": "h1",
  "slash.search.h2": "h2",
  "slash.search.h3": "h3",
  "slash.search.bulleted": "bulleted list",
  "slash.search.numbered": "numbered list",
  "slash.search.blockquote": "blockquote",
  "slash.search.hr": "horizontal rule",
  "slash.search.card": "card",
  "slash.search.mention": "mention",
  "slash.search.codeBlock": "code block",
  "slash.search.embed": "embed board",
  // menus
  "menu.add-column-before": "Add column before",
  "menu.add-column-after": "Add column after",
  "menu.add-row-before": "Add row before",
  "menu.add-row-after": "Add row after",
  "menu.merge-cells": "Toggle merge cells",
  "menu.toggle-header-row": "Toggle header row",
  "menu.delete-column": "Delete column",
  "menu.delete-row": "Delete row",
  "menu.delete-table": "Delete table",
  "menu.toggle-expand-to-page-size": "Toggle full width",
  "menu.add-comment": "Add comment",
  "menu.heading": "Heading %{level}",
  "menu.bold": "Bold",
  "menu.italic": "Italic",
  "menu.strikethrough": "Strikethrough",
  "menu.underline": "Underline",
  "menu.check-list": "Checklist",
  "menu.bullet-list": "Bullet list",
  "menu.ordered-list": "Ordered list",
  "menu.horizontal-rule": "Horizontal rule",
  "menu.link": "Link",
  "menu.quick-card": "Quick card",
  "menu.blockquote": "Block quote",
  "menu.codeblock": "Code block",
  "menu.code": "Inline code",
  "menu.undo": "Undo",
  "menu.redo": "Redo",
  "menu.table-cell-color": "Cell color",
  "menu.clear-table-cell-color": "Clear cell color",
  "menu.align-left": "Align left",
  "menu.align-center": "Align center",
  "menu.align-right": "Align right",
  "menu.align-justify": "Align justify",
  "editor.clickToDownload": "Click to download",
  "editor.loading": "Loading",
  "editor.characterLimitReachedTryFile": "Character limit reached. For larger content, you can attach files.",
  "editor.uploading": "Uploading",
  "editor.genericFileError": "Your file could not be uploaded.",
  // billing
  ["billing.unlimitedMembers"]: "Unlimited team members",
  ["billing.unlimitedSpaces"]: "Unlimited spaces",
  ["billing.unlimitedBoards"]: "Unlimited boards",
  ["billing.unlimitedCardsAndPages"]: "Unlimited cards and pages",
  ["billing.unlimitedViews"]: "Unlimited views",
  ["billing.category.workspaceMembers"]: "Workspace members",
  ["billing.category.spaces"]: "Spaces",
  ["billing.category.boards"]: "Boards",
  ["billing.category.cardsAndPages"]: "Cards and pages",
  ["billing.category.views"]: "Views",
  ["billing.category.fileSize"]: "File size",
  ["billing.category.privateSpaces"]: "Private spaces",
  ["billing.category.userPermissions"]: "User permissions",
  ["billing.category.guestAccounts"]: "Guest accounts",
  ["billing.noPrivateSpaces"]: "No private spaces",
  ["billing.everyoneIsAdmin"]: "Everyone is admin",
  ["billing.noGuestAccounts"]: "No guest accounts",
  ["billing.5mbFileSizeLimit"]: "5MB file size limit",
  ["billing.noFileSizeLimit"]: "No file size limit",
  ["billing.unlimitedPrivateSpaces"]: "Unlimited private spaces",
  ["billing.2Spaces"]: "2 spaces",
  ["billing.adminRolesAndPermissions"]: "Admin roles & permissions",
  ["billing.unlimitedCards"]: "Unlimited cards",
  ["billing.sharePagesOnTheWeb"]: "Share pages on the web",
  ["billing.50Pages"]: "50 pages",
  ["billing.unlimitedPages"]: "Unlimited pages",
  ["billing.indexSharedPages"]: "Index shared pages in search engines",
  ["billing.privateSpaces"]: "Private spaces",
  ["billing.timelineListAndBoardView"]: "Timeline, list, & board view",
  ["billing.guestAccounts"]: "Guest accounts",
  ["billing.monthly"]: "Monthly",
  ["billing.yearly"]: "Yearly (-20%)",
  ["billing.currentPlan"]: "Current plan",
  ["billing.yourChosenPaymentMethodIs"]: "Your chosen payment method is %{method}",
  ["billing.thisIsThePaymentMethod"]: "This is the payment method we will use for future payments. You can change it at any time.",
  ["billing.billing"]: "Billing",
  ["billing.planAndBilling"]: "Plan and Billing",
  ["billing.paymentMethod"]: "Payment method",
  ["billing.cardEndingIn"]: "%{cardType} ending in %{last4}",
  ["billing.manageBillingDetails"]: "Manage billing details",
  ["billing.viewBillingDetails"]: "View billing details",
  ["billing.updatePaymentDetails"]: "Update payment details",
  ["billing.sendNewInvoicesTo"]: "Send new invoices to",
  ["billing.previousInvoices"]: "Previous invoices",
  ["billing.plan"]: "Plan",
  ["billing.manageWhichPlan"]: "Manage which plan the workspace uses",
  ["billing.standard"]: "Standard",
  ["billing.changePlan"]: "Change plan",
  ["billing.free"]: "Free",
  ["billing.upgrade"]: "Upgrade",
  ["billing.noPaymentMethod"]: "No payment method",
  ["billing.thereIsNoPaymentMethod"]: "There is no payment method associated with this workspace. A payment method will appear here once you’ve selected a paid plan.",
  ["billing.selectAPaidPlan"]: "Select a paid plan",
  ["billing.upgradePlan"]: "Upgrade to this plan",
  ["billing.downgradePlan"]: "Downgrade to this plan",
  ["billing.downgradeToFree"]: "Downgrade to free",
  ["billing.viewYourPaymentMethodInStripe"]: "View your payment method in Stripe",
  ["billing.weBillTheWorkspacePayment"]: "We bill the workspace payment method when an invitation is accepted.",
  ["billing.checkThePlanPanel"]: "Check the plan panel for a per-seat cost estimate.",
  ["billing.12"]: "$12",
  ["billing.10"]: "$10",
  ["billing.dollarPrice"]: "$%{price}",
  ["billing.numberSpaces"]: "%{number} spaces",
  ["billing.numberBoards"]: "%{number} boards",
  ["billing.fileSizeLimit"]: "%{size}MB file size limit",
  ["billing.sprints"]: "Sprints",
  ["billing.projectsAndRoadmap"]: "Projects & roadmap",
  ["billing.ssoAndSaml"]: "SSO & SAML",
  ["billing.unlimitedFileUploads"]: "Unlimited file uploads",
  ["billing.cardAndPageTemplates"]: "Card & page templates",
  ["billing.guestUsers"]: "Guest users",
  ["billing.meetingTranscription"]: "Meeting transcription",
  ["billing.aiNoteTemplates"]: "AI note templates",
  ["billing.askAiSearch"]: "Ask AI search",
  ["billing.perUserPerMonth"]: "/ user / month",
  ["billing.billedYearly"]: "billed yearly",
  ["billing.planStatus"]: "Plan status",
  ["billing.yourCurrentPlanIsNotSetToRenew"]: "Your current plan is not set to renew",
  ["billing.on"]: "On",
  ["billing.dateYourWorkspaceWillDowngrade"]: "your workspace will downgrade to the Free plan. Until then you can still invite people to this workspace, but you will not be able to exceed",
  ["billing.workspaceMembers"]: "workspace members",
  ["billing.turnRenewalBackOn"]: "Turn renewal back on",
  ["billing.youCanStillInvite"]: "You can still invite people to this workspace, but you cannot exceed",
  ["billing.workspaceFullError"]: "Workspace member limit reached. A workspace admin can raise it.",
  ["billing.genericJoinError"]: "Could not join workspace.",
  ["billing.startsOn"]: "Starts on %{date}",
  ["billing.switchToYearly"]: "Switch to yearly (-20%)",
  ["billing.switchToMonthly"]: "Switch to monthly",
  ["billing.metadata"]: "Everything in %{plan}, plus...",
  ["billing.talkToOurExperts"]: "Talk to our experts",
  ["billing.samlAndScim"]: "SAML & SCIM",
  ["billing.auditLogs"]: "Audit logs",
  ["billing.customBilling"]: "Custom billing",
  ["billing.prioritySupport"]: "Priority support",
  ["billing.unlimitedChildCards"]: "Unlimited child cards",
  ["billing.publishPagesToTheWeb"]: "Publish pages to the web",
  ["billing.calendarLayout"]: "Calendar layout",
  ["billing.customViews"]: "Custom views",
  ["billing.advancedSearch"]: "Advanced search",
  ["billing.views"]: "Views",
  ["billing.timelineLayout"]: "Timeline layout",
  ["billing.liveChatSupport"]: "Live chat support",
  ["billing.guestsUsersAreFree"]: "Guest users are free on your current plan.",
  ["billing.newMembersAreBilledProRata"]: "New members are billed pro-rata for the remainder of your annual billing cycle.",
  ["billing.workspacePaymentMethodWillBeCharged"]: "The workspace payment method will be charged at the end of the month in which they join.",
  ["billing.learnModeAboutBilling"]: "Learn more about billing",
  ["billing.guestViewOnly"]: "Guest – view only",
  // global
  ["global.text.create"]: "Create",
  ["option.label.cards"]: "Cards",
  ["option.label.pages"]: "Pages",
  ["option.label.boards"]: "Boards",
  ["option.label.epics"]: "Projects",
  ["option.label.spaces"]: "Spaces",
  ["option.label.showArchived"]: "Show archived",
  ["search.message.noResults"]: "Not found",
  ["global.text.discardDraft"]: "Discard draft",
  switchAccount: "Switch account",
  all: "All",
  search: "Search",
  searchPlaceholder: "Search or ask a question...",
  close: "Close",
  send: "Send",
  resendInviteLink: "Resend invite link",
  addComment: "Add a comment",
  comment: "Comment",
  replyToComment: "Reply to comment...",
  writeComment: "Write a comment...",
  draftComment: "Draft comment",
  finaliseCard: "Finalise card",
  comments: "Comments",
  createBoard: "Create board",
  createPage: "Create page",
  delete: "Delete",
  edit: "Edit",
  remove: "Remove",
  done: "Done",
  cancel: "Cancel",
  cancelAndDiscard: "Cancel and discard",
  enterBoardTitle: "Board title",
  create: "Create",
  join: "Join",
  couldntJoinSpace: "Could not join space, try again later.",
  untitled: "Untitled",
  containsNoContent: "Contains no content.",
  ama: "AMA",
  me: "Me",
  assigned: "Assigned",
  mentions: "Mentions",
  visited: "Visited",
  saved: "Saved",
  notifications: "Notifications",
  selectWhereWwhenWillNotified: "Choose how you want to be notified",
  recivePersonalNotification: "Receive personal notifications in Slack",
  notifyMe: "Notify me when",
  save: "Save",
  saveChanges: "Save changes",
  archived: "Archived",
  archive: "Archive",
  watch: "Watch",
  unwatch: "Unwatch",
  cardArchived: "Card is archived.",
  cardArchivedByCard: "Card is archived.",
  cardArchivedByList: "Card is part of an archived list. Move to active list to restore.",
  cardArchivedByBoard: "Card is part of an archived board. Move to active board to restore.",
  epicArchived: "Project is archived.",
  epicArchivedByEpic: "Project is archived.",
  epicArchivedByList: "Project is part of an archived list. Move to active list to restore.",
  boardArchived: "Board is archived.",
  isArchived: "is archived",
  pageArchived: "Page is archived.",
  cellMerge: "Cell Merge",
  new: "New",
  view: "View",
  project: "space",
  spaces: "Spaces",
  teamId: "team id",
  deleteCommentPopupMessage: "Are you sure you want to delete this comment?",
  deleteMessage: "Delete comment",
  archiveResource: "Archive %{type}",
  restoreResource: "Restore %{type}",
  deleteResource: "Delete %{type}",
  deleteSuccess: "%{name} %{type} is deleted",
  archiveSuccess: "%{name} %{type} is archived",
  restoreSuccess: "%{name} %{type} is restored",
  deleteError: "Couldn’t delete %{name} %{type}",
  archiveError: "Couldn’t archive %{name} %{type}",
  restoreError: "Couldn’t restore %{name} %{type}",
  addLink: "Add link",
  couldntDeleteComment: "Could not delete comment, please try again",
  couldntLoadComments: "Could not load comments.",
  commentOnPage: "Comment on page",
  commentOn: "Comment on",
  emailPlaceholder: "e.g. you@example.com",
  signOut: "Sign Out",
  leave: "Leave",
  browseAllSpaces: "Browse All Spaces",
  preview: "Preview",
  goToCard: "Go to card",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  notFoundPageHeader: "There’s been a glitch...",
  notFoundPageContent: "We’re not quite sure what went wrong. You can go back, or try looking on our Help Center if you need a hand.",
  addCard: "Add card",
  addProject: "Add project",
  next: "Next",
  addToCard: "Add to card",
  checklist: "Checklist",
  moveList: "Move list",
  board: "Board",
  timeline: "Timeline",
  templates: "Templates",
  cardTemplates: "Card templates",
  pageTemplates: "Page templates",
  saveCardContentYouRepeatedlyUse: "Save content you repeatedly use and apply it when you create cards",
  savePageContentYouRepeatedlyUse: "Save content you repeatedly use and apply it when you create pages",
  createCardTemplate: "Create card template",
  editCardTemplate: "Edit card template",
  searchTemplates: "Search templates",
  name: "Name",
  noCardTemplates: "No card templates",
  noPageTemplates: "No page templates",
  calendar: "Calendar",
  showAllCards: "Show all cards",
  hideAllCards: "Hide all cards",
  showWeekends: "Show weekends",
  youCanCreateATemplateAbove: "You can create a template above",
  youCanCreateABoardFrom: "You can create a board from the app sidebar",
  createPageTemplate: "Create page template",
  editPageTemplate: "Edit page template",
  templateNameAndIcon: "Template name and icon",
  thisIsHowPeopleFindTemplate: "This is how people will find your template later",
  shortAndDescriptive: "Short and descriptive",
  templateNameCannotBeEmpty: "Template name cannot be empty",
  templateSpace: "Template space(s)",
  whichSpacesWillThisTemplateBeAvailableIn: "Which spaces will this template be available in?",
  templateSpaceShouldHaveAtLeastOneSpaceSelected: "Template space should have at least one space selected",
  noSpacesFound: "No spaces found.",
  allSpaces: "All spaces",
  peopleWillBeAbleToEditThisAfterTheyApplyTheTemplate: "People will be able to edit this after they apply the template",
  theseWillBeAddedToTheCardYouApplyTheTemplateTo: "These will be added to the card you apply the template to",
  taskDescription: "Card description",
  pageBody: "Page body",
  saveTemplate: "Save template",
  templateNotFound: "Template not found",
  addAssignees: "Add assignees",
  removeAssignees: "Remove assignees",
  changeAssignees: "Change assignees",
  setTags: "Set tags",
  selectAll: "Select all",
  createInThisBoard: "Create in this board",
  setThisStatus: "Set this status",
  chooseABoard: "Choose a board",
  chooseABoardToUseThisField: "Choose a board to use this field",
  ifYouLeaveThisPageAnyChangesWillBeLost: "If you leave this page, any changes you’ve made to this template will be lost.",
  uploadFailedClickToRetry: "Upload failed, click to retry",
  areYouSureYouWantToDeleteTheTemplate: 'Are you sure you want to delete the "%{templateName}" template?',
  applyTemplate: "Apply template",
  noTemplates: "No templates.",
  manageTemplates: "Manage templates",
  uploadFilesForTemplatesIsDisabled: "File uploads are disabled in templates",
  uploadFilesIsDisabled: "File uploads are disabled",
  noTagsFoundSelectBoardToSeeTags: "No tags found. Select a board to see tags available in that space, or",
  createNewWorkspaceTagInSettings: "create a new workspace tag in settings.",
  noTitle: "No title",
  addChecklist: "Add checklist",
  title: "Title",
  add: "Add",
  addItem: "Add new item",
  archiveList: "Archive list",
  actions: "Actions",
  reply: "Reply...",
  replies: "Replies",
  description: "Description",
  cardDescriptionPlaceholder: "Write a description...",
  templateDescriptionPlaceholder: "Enter a description...",
  card: "Card",
  space: "Space",
  page: "Page",
  workspaceLabel: "Enter workspace name",
  workspacePlaceholder: "Workspace name",
  roboto: "Roboto",
  sansserif: "Sans Serif",
  serif: "Serif",
  mono: "Mono",
  monospace: "Monospace",
  download: "Download",
  move: "Move",
  background: "Background",
  share: "Share",
  upload: "Upload",
  paste_image_link: "Paste image link",
  embed_image: "Embed image",
  drag_and_drop: "Drag and drop",
  supported_files: "Supported files",
  maximum_size: "Maximum size",
  createNewPage: "Create new page",
  createNewBoard: "Create new board",
  newPage: "New page",
  addNewPage: "Add new page",
  newBoard: "New board",
  addNewBoard: "Add new board",
  oneColumn: "1 column",
  twoColumns: "2 columns",
  previewStillUpdating: "Preview still updating...",
  emptyPage: "Empty page",
  searchSuperthread: "Search Superthread",
  attachFrom: "Attach from...",
  searchUnsplash: "Search Unsplash",
  fullWidth: "Full width",
  largeText: "Large text",
  space___: "Space...",
  cannotExcludeAll: "Cannot exclude all",
  mustIncludeAtLeastOne: "Must include at least one",
  type: "Type",
  noResultsFound: "No results found",
  cardStatus: "Card status",
  makeItPrivate: "Make it private",
  thisSpaceIsPrivate: "This space is private",
  privateSpaceDescription: "When a space is set to private, it can only be joined by invitation.",
  boards: "Boards",
  boardsCount_one: "%{count} board",
  boardsCount_other: "%{count} boards",
  cardsCount_one: "%{count} card",
  cardsCount_other: "%{count} cards",
  from: "from",
  hiddenMember: "Hidden member",
  hiddenMemberDesc: "This person does not share any spaces with you",
  linkTextLabel: "Text",
  linkUrlLabel: "Link",
  linkTextPlaceholder: "Add text...",
  linkUrlPlaceholder: "Add link...",
  editList: "Edit list",
  copyList: "Copy List",
  sortBy: "Sort by",
  moveAllCards: "Move all cards",
  archiveAllCards: "Archive all cards",
  enterResourceTitle: "Enter %{type} title...",
  open: "Open",
  openCardInBoard: "Open card in board",
  editTitle: "Edit title",
  editTags: "Edit tags",
  editMembers: "Edit members",
  copy: "Copy",
  attachment: "Attachment",
  startDate: "Start date",
  dueDate: "Due date",
  cover: "Cover",
  tags: "Tags",
  activity: "Activity",
  created: "Created",
  updated: "Updated",
  reload: "Reload",
  timePeriod: "Time period",
  cardsAdded: "Cards added",
  cardsFinished: "Cards finished",
  netChange: "Net change",
  last7Days: "Last 7 days",
  last14Days: "Last 14 days",
  last30Days: "Last 30 days",
  cardsAddedBetween: "Unique cards added between",
  cardsAddedTo: "Unique cards added to",
  between: "between",
  deletedCards: "Deleted cards reduce the count",
  moreCardsAddedThanFinished: "%{number} more cards were added than finished",
  sameNumberOfCardsAddedAndFinished: "The same number of cards were added and finished",
  moreCardsFinishedThanAdded: "%{number} more cards were finished than added",
  oneMoreCardAddedThanFinished: "1 more card was added than finished",
  oneMoreCardFinishedThanAdded: "1 more card was finished than added",
  convertToCard: "Convert to card",
  searchForTag: "Search for tag",
  createTag: "Create tag",
  tagName: "Tag name",
  editTagName: "Edit tag name",
  hideCheckedItems: "Hide checked items",
  showCheckedItems: "Show checked items",
  deleteChecklist: "Delete checklist",
  attachments: "Attachments",
  versionHistory: "Version History",
  profile: "Profile",
  settings: "Settings",
  email: "Email",
  firstNamePlaceholder: "Enter first name",
  lastNamePlaceholder: "Enter last name",
  displayNamePlaceholder: "Enter display name",
  profileBasicInfoSubtitle: "Personal and contact info",
  uploadProfileImageRule: "Image should be PNG, GIF or JPG format no larger than 3MB. This will be shown as your avatar across the app.",
  workspaceLogo: "Pick a workspace logo. Recommended size is 256x256px",
  logoSaved: "Logo saved",
  logoRemoved: "Logo removed",
  removeCover: "Remove cover",
  uploadCoverImage: "Upload cover image",
  list: "List",
  addChildCard: "Add child card",
  searchForCard: "Search for existing card",
  newChildCard: "Create new child card",
  cancelSearch: "Cancel search",
  computer: "Computer",
  setDueDate: "Set due date",
  months: "January,February,March,April,May,June,July,August,September,October,November,December",
  monthsAbbreviation: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
  daysAbbreviation: "MO,TU,WE,TH,FR,SA,SU",
  daysAbbreviationLong: "Mon,Tue,Wed,Thu,Fri,Sat,Sun",
  weekDays: "Monday,Tuesday,Wednesday,Thursday,Friday,Saturday,Sunday",
  time: "Time",
  dueDateReminder: "Due date reminder",
  weekBefore: "Week before",
  daysBefore: "Days before",
  dayBefore: "Day before",
  hoursBefore: "Hours before",
  hourBefore: "Hour before",
  onTime: "On time",
  none: "None",
  due: "Due",
  insertFile: "Insert file",
  addImage: "Add image",
  edited: "edited",
  insert: "Insert",
  overdue: "Overdue",
  continue: "Continue",
  createdBy: "Created by",
  press: "Press",
  toClose: "to close",
  cards: "Cards",
  on: "on",
  useArrowKeys: "Use arrow keys",
  toNavigate: "to navigate, select with",
  sending: "Sending invite link..",
  inviteDoesntExist: "Invite link doesn’t exist.",
  couldntResendLink: "Couldn’t resend the invite link.",
  newInviteLinkSent: "We sent you a new invite link, please check your email.",
  inviteLinkAccepted: "Invite link already accepted.",
  inviteNoLongerValid: "Invite link is no longer valid. Please request a new invite link.",
  inviteCodeIncorrect: "Incorrect invite link. Click below to resend.",
  thereAreNoFreeSeatsForThisWorkspace: "There are no free seats for this workspace",
  thisWorkspaceCantAcceptAnyMoreMembers: "This workspace cannot accept any more members. A workspace admin can raise the limit, or an existing member can leave the workspace to open a seat.",
  spaceAccess: "Space access",
  changeToPrivateSpace: "All existing members of this space will still be members after it is made private. No new members will be able to join unless they are invited.",
  changeToOpenSpace: "All members of the workspace will be able to find and join this space, and see its contents.",
  changeToPrivate: "Change to private",
  changeToOpen: "Change to open",
  changeToPrivateSpaceTitle: "Change to private space?",
  changeToOpenSpaceTitle: "Change to open space?",
  ownersAdminsCreatorOfSpace: "Only workspace owners, admins, and the creator of the space can change this setting",
  member: "Member",
  notMember: "Not a member",
  links: "Links",
  createNewView: "Create view",
  newView: "New view",
  workspace: "Workspace",
  views: "Views",
  roadmap: "Roadmap",
  myViews: "My views",
  workspaceViews: "Workspace views",
  private: "Private",
  lastUpdate: "Last update",
  viewType: "View type",
  filters: "Filters",
  filter___: "Filter...",
  filters___: "Filters...",
  filterBy: "Filter by",
  filter: "Filter",
  content: "content",
  status: "Status",
  subscriber: "subscriber",
  creator: "creator",
  tag: "Tag",
  subscribers: "subscribers",
  creators: "creators",
  shareWithWorkspace: "Share with workspace",
  discard: "Discard",
  pageTitlePlaceholder: "Untitled page",
  markAllAsRead: "Mark all as read",
  addTo: "Added to",
  removeFrom: "Removed from",
  movedTo: "%{name} moved",
  notificationCreated: "%{name} created",
  notificationAdded: "%{name} added",
  commented: "Commented",
  mentioned: "Mentioned",
  dropFilesLabel: "Drag and drop files here",
  back: "Back",
  typeContent: "Type a content",
  hasDueDate: "Has due date",
  dueSoon: "Due soon",
  dueToday: "Due today",
  epic: "Project",
  epics: "Projects",
  searchForEpic: "Search for project",
  changedEpicFrom: "changed project from",
  addedToEpicCard: "added this card to project",
  removedFromEpicCard: "removed this card from project",
  epicInherited: "Project inherited from parent card",
  untitledView: "Untitled view",
  cannotSaveUntitledView: "Cannot save untitled view",
  viewSaved: "view saved",
  pagePlaceholder: "Write something...",
  newViewTitele: "New view title",
  ["global.placeholder.pagePlaceholder"]: "Write something...",
  ["global.placeholder.focusedStatePlaceholder"]: "@ to mention anything, / for commands...",
  ["global.placeholder.focusedStatePlaceholderMobile"]: "@ to mention, / for commands...",
  checkListItemPlaceholder: "@ to mention anything...",
  viewAll: "View all",
  filterByUnread: "Filter by unread",
  pagePublished: "Page published",
  restore: "Restore",
  cardPathArchivedBoard: "This card is in an archived board",
  restoreMakeChange: "Click here to restore",
  boardUpdated: "Board updated",
  defaultBoardLayoutChangedTo: "Default layout changed to %{layoutStyle}",
  esc: "Esc",
  assignee: "Assignee",
  assignees: "Assignees",
  no_assignee: "No assignee",
  findMembers: "Find members...",
  inviteExternalPeople: "Invite external people",
  notInThisSpace: "Not in this space",
  inThisSpace: "In this space",
  notWorkspaceMember: "That person isn’t a member of this workspace yet",
  anchorLinkErrorMessage: "Couldn’t find that link",
  childCard: "Child card",
  parentCards: "Parent cards",
  blocking: "Blocking",
  blocked: "Blocked",
  favourites: "Favourites",
  dragOr: "Drag or",
  somethingHere: "something here",
  linkCopiedToClipboard: "Link copied to clipboard.",
  tomorrow: "Tomorrow",
  invitationsSent: "Invitations sent.",
  invitationsFailed: "Invitations failed.",
  retry: "Retry",
  undo: "Undo",
  boardMovedToSpace: "Board moved to space",
  pageMovedToSpace: "Page moved to space",
  boardNotMoved: "Board move cancelled.",
  pageNotMoved: "Page move cancelled.",
  newTag: "New tag",
  tagExists: "Tag already exists",
  toggleSection: "Toggle section",
  toggleContent: "Empty section. Click to write or copy content here.",
  removeChildCardFail: "Failed to remove child card",
  moveChildCardFail: "Failed to move child card",
  addChildCardFail: "Failed to add child card",
  cantRemoveMembers: "You can’t remove members from the default space",
  cantRemoveMembersFromSpace: "You can’t remove members from this space",
  cannotModifyMembers: "You don’t have permission to change members",
  inactiveMembersCannotBeAdded: "Inactive members cannot be added to spaces",
  duplicate: "Duplicate",
  setParentCard: "Set parent card",
  duplicateCard: "Duplicate card",
  duplicateBoard: "Duplicate board",
  duplicateBoardDescription: "Any cards in this board will not be duplicated. Choose a space and name for the duplicated board.",
  duplicateTo: "Duplicate to",
  duplicateDefaultTitle: "Enter new title (defaults to original)",
  duplicates: "Duplicates",
  duplicateOf: "Duplicate of",
  markAsBlockedBy: "Mark as blocked by",
  markAsBlocking: "Mark as blocking",
  markAsRelatedTo: "Mark as related to",
  markAsDuplicateOf: "Mark as duplicate of",
  blocks: "Blocks",
  blockedBy: "Blocked by",
  related: "Related",
  relatedEpics: "Related projects",
  markedEpicAsBlocking: "marked this project as blocking",
  markedEpicAsBlockedBy: "marked this project as blocked by",
  markedEpicAsRelated: "marked this project as related to",
  markedEpicAsDuplicate: "marked this project as a duplicate of",
  relatedCards: "Related cards",
  markedCardAsBlocking: "marked this card as blocking",
  markedCardAsBlockedBy: "marked this card as blocked by",
  markedCardAsRelated: "marked this card as related to",
  markedCardAsDuplicate: "marked this card as a duplicate of",
  removedCardRelationship: "removed relationship",
  noListsInBoard: "No lists in board",
  noBoardsInSpace: "No boards in space",
  noBoardsInThisSpace: "No boards in this space",
  emptyList: "Empty list",
  cardDuplicated: "Card duplicated",
  boardDuplicated: "Board duplicated",
  viewDuplicated: "View duplicated",
  viewDeleted: "View deleted",
  cardDuplicateFailed: "Failed to duplicate card",
  boardDuplicateFailed: "Failed to duplicate board",
  viewDuplicateFailed: "Failed to duplicate view",
  cantUndoneAction: "This action can’t be undone.",
  eachSpaceCanContain: "Each space can contain as many boards as you like",
  browseSpaces: "Browse spaces",
  popupSpaceDescription: "Organise work in spaces. They’re usually named after a team, project, or high level objective.",
  eachSpaceCanContainMultiple: "Each space can contain multiple ",
  pagesLowercase: "pages",
  kanbanBoards: "kanban boards",
  and: "and",
  removeFromParent: "Remove from parent",
  removeChildCard: "Remove child card",
  changeCardParent: "Change card parent",
  changeParent: "Change parent",
  changeParentDescription: "This card has “%{card_title}” as a parent. Do you want to change the parent to the current card?",
  editChildCardDetails: "Edit child card details",
  copyLink: "Copy link",
  childCardTitleNotUpdated: "Child card title not updated.",
  addNewChildCard: "Add new child card",
  enterCardTitleOrFind: "Enter card title or find existing cards",
  createNewCard: "Create new card",
  unsplashImage: "Unsplash image",
  shareToWeb: "Share to web",
  publishesSubpagesButNoComments: "Publishes subpages, but not comments",
  pageIsSharedToWeb: "Page is shared to web",
  shared: "Shared",
  openSharedPage: "Open shared page",
  pageIsSetToPrivate: "Page is set to private",
  profileSettings: "Profile settings",
  switchWorkspace: "Switch workspace",
  archivedItems: "Archived items",
  logOut: "Log out",
  helpFeedback: "Help & feedback",
  help: "Help",
  joinSlack: "Join our Slack community",
  askQuestions: "Ask questions and help others",
  contactUs: "Contact us",
  letUsKnow: "Let us know if there’s an issue or a question",
  assign: "Assign",
  unassign: "Unassign",
  pageIsNoLongerShared: "Page is no longer shared to web",
  favourite: "Favourite",
  unfavourite: "Unfavourite",
  allowSearchEngines: "Allow search engines to index this page",
  searchEngineIndexing: "Search engine indexing",
  searchIndexingEnabled: "Search indexing enabled",
  searchIndexingDisabled: "Search indexing disabled",
  attachIconFrom: "Attach icon from...",
  addIcon: "Add icon",
  addCoverImage: "Add cover image",
  pageDuplicated: "Page duplicated",
  pageDuplicateFailed: "Failed to duplicate page",
  copyOf: "Copy of",
  displayNameDescription: "This could be your first name, or a nickname. It will be displayed around the app.",
  embedVideo: "Embed Youtube video",
  removePullRequest: "Remove pull request",
  viewOnGitHub: "View on GitHub",
  setUpGHIntegration: "Set up GitHub integration",
  integrateSuperthread: "Integrate Superthread into your favorite git client.",
  githubIntegradionDescripiton: "Link Superthread cards to GitHub pull requests. Include a Superthread card ID (e.g C-123) in your branch name or pull request title to automatically show the PR status in the card.",
  connectGithub: "Connect GitHub",
  connectedAccounts: "Connected accounts",
  integrationConnectedToSuperthread: "%{integrationName} connected to Superthread",
  enabledBy: "Enabled by",
  select: "Select",
  integrations: "Integrations",
  importer: "Importer",
  github: "GitHub",
  github_pull_request: "GitHub",
  gitlab: "GitLab",
  jira: "Jira",
  trello: "Trello",
  importFrom: "Import from",
  selectYour: "Select your",
  usersToSuperthreadUsers: "users to Superthread users",
  issues: "issues",
  teams: "teams",
  setUpImport: "Set up import",
  importHistory: "Import history",
  importBoards: "Import boards",
  selectWhichBoards: "Select which boards from",
  runImport: "Run the import",
  quickImport: "Quick import",
  importBoardIntoExsistingSpace: "Custom import",
  start: "Start",
  started: "Started",
  DontImport: "Don’t import",
  map: "Map",
  dontImportUsers: "Don’t import users",
  ImportUsers: "Import users",
  importAs: "Import as...",
  selectUser: "Select user",
  inviteByEmail: "Invite by email",
  users: "Users",
  options: "Options",
  chooseAditionslOptions: "Choose aditional options",
  importAttachments: "Import attachments",
  includeCardCoverImages: "Include card cover images",
  importInProgress: "Import in progress",
  importError: "Import completed with errors",
  importSuccess: "Import completed",
  importUnstarted: "Import unstarted",
  timeStarted: "Time started",
  completed: "Completed",
  showCompleted: "Show done",
  details: "Details",
  finish: "Finish",
  validEmail: "Please enter a valid email address.",
  emailAdresses: "Email addresses, comma separated",
  person1Email: "person1@example.com, person2@example.com…",
  addToSpaces: "Add to spaces",
  addSpaces: "Add spaces",
  browseProjects: "Browse all spaces",
  createAndBrowseSpaces: "Browse and create spaces",
  nameIsRequired: "A name is required",
  noProjectFound: "No more spaces to add",
  memberExplanation: "Members can browse and join any space in the workspace",
  adminExplanation: "Admins have more access to workspace settings",
  guestExplanation: "Guests have limited workspace access and only see spaces they’re added to",
  connect: "Connect",
  selectBoardImport: "Select boards you want to import",
  selectUsersImport: "Select users you want to import",
  notImportArchivedIssues: "We won’t import archived issues.",
  importTasksIntoSuperthread: "Import your existing tasks into Superthread.",
  connectAccount: "Connect your account",
  completedOn: "Completed on",
  importedBy: "Imported by:",
  timeCreated: "Time created:",
  createdDate: "Created date",
  updatedDate: "Updated date",
  numberOfImportedBoards: "Number of imported boards:",
  numberOfImportedUsers: "Number of imported users:",
  importingIsFinished: "Import finished",
  importing: "Your import has finished",
  selectService: "Select where we should import issues from. We’ll ask for your authentication details so we can access their API. We won’t import any data until you’ve confirmed your choices in the final step.",
  account: "Account",
  importers: "Importers",
  general: "General",
  manageWorkspaceSettings: "Manage general workspace settings",
  dangerZone: "Danger zone",
  notOwnerOrAdmin: "You are not an owner or admin of this workspace",
  archiveWorkspace: "Archive workspace",
  archiveWorkspaceDescription: "All members will lose access to a workspace if it is archived. Any content shared publicly will still be available.",
  archiveWorkspaceDescriptionDetail: "All members will lose access to this workspace. If you want to undo this action, email contact@superthread.com.",
  deleteWorkspace: "Delete workspace",
  deleteWorkspaceDescription: "All members will lose access to a workspace and its data if it is deleted. This cannot be undone.",
  deleteWorkspaceDescriptionDetail: "All members will lose access to this workspace and its data. This cannot be undone.",
  avatarAppearance: "Avatar appearance",
  uploadImage: "Upload image",
  successfullySaved: "Successfully saved",
  errorSave: "Your changes could not be saved",
  copyURL: "Copy URL",
  copyUrl: "Copy URL to clipboard",
  copyCardUrl: "Copy card URL to clipboard",
  copyPageUrl: "Copy page URL to clipboard",
  copyBoardUrl: "Copy board URL to clipboard",
  copySpaceUrl: "Copy space URL to clipboard",
  copyGitBranchNameToClipboard: "Copy git branch name to clipboard",
  copyGitBranchName: "Copy git branch name",
  branchCopiedToClipboard: "Git branch name copied to clipboard",
  subscribe: "Subscribe",
  unsubscribe: "Unsubscribe",
  pullRequestAutomation: "Pull request automation",
  prAutomationDescription: "Move cards in Superthread when pull requests are updated in GitHub.",
  whenACardIsLinkedToPR: "When a card is linked to a pull request",
  whenPRTargetsTheBranch: "When the pull request targets the branch",
  addBranchSpecificAutomation: "Add branch-specific automation",
  automationMustHaveBranchName: "An automation must have a branch name. These rules will be ignored.",
  addBranchSpecificAutomationErrorAlreadyExists: "There is already an automation for that branch name. These rules will be ignored.",
  invalidGitBranchName: "That is not a valid branch name. These rules will be ignored.",
  branchSpecificAutomationAdded: "Branch-specific automation added.",
  branchSpecificAutomationUpdated: "Branch-specific automation updated.",
  branchSpecificAutomationRemoved: "Branch-specific automation removed.",
  deleteAutomation: "Delete automation",
  deleteThisAutomation: "Delete this automation",
  deleteAutomationConfirmation: "This set of rules will be deleted and cannot be recovered.",
  whenPRChangesTo: "When PR changes to",
  moveCardToList: "Move card to list",
  doNotMove: "Do not move",
  draftPROpened: "Draft PR opened",
  pROpened: "PR opened",
  pRReviewRequest: "PR review request",
  pRMerged: "PR merged",
  pRClosed: "PR closed",
  noListInBoard: "No lists in this board",
  unassigned: "Unassigned",
  viewParentCard: "View parent card",
  changeParentCard: "Change parent card",
  removeParentCard: "Remove parent card",
  goToParentCard: "Go to parent card",
  discardAndClose: "Discard and close",
  changeStatus: "Change status",
  createCardsInSelectedBoard: "Always create cards in the selected board",
  createCardIn: "Create card in",
  maxFileSize: "Max. file size: 5MB",
  addAttachment: "Add attachment",
  createChecklist: "Create checklist",
  assignedToMe: "Assigned to me",
  movedTAaNewList: "Moved to a new list",
  moved: "Moved",
  published: "Published",
  cardComments: "Card comments",
  pageComments: "Page comments (including replies in threads)",
  movedBetweenSpaces: "Moved to a different space",
  addedToASpace: "Added you to a space",
  noduedate: "No due date",
  ["now+2d"]: "2 days from now",
  ["now+3d"]: "3 days from now",
  ["now+1w"]: "1 week from now",
  ["now+2w"]: "2 weeks from now",
  ["now+3w"]: "3 weeks from now",
  ["now+1M"]: "1 month from now",
  ["now+2M"]: "2 months from now",
  ["now+3M"]: "3 months from now",
  ["now+6M"]: "6 months from now",
  ["now+1y"]: "1 year from now",
  now: "Today",
  nowActivity: "now",
  ["now-1h"]: "1 hour ago",
  ["now-4h"]: "4 hours ago",
  ["now-1d"]: "Yesterday",
  ["now-2d"]: "2 days ago",
  ["now-3d"]: "3 days ago",
  ["now-1w"]: "1 week ago",
  ["now-2w"]: "2 weeks ago",
  ["now-3w"]: "3 weeks ago",
  ["now-1M"]: "1 month ago",
  ["now-2M"]: "2 months ago",
  ["now-3M"]: "3 months ago",
  ["now-6M"]: "6 months ago",
  ["now-1y"]: "1 year ago",
  anywhereYouAreMentioned: "Anywhere you are mentioned (regardless of subscribed status etc.)",
  anyCommentsOnResources: "Any comments on resources you are subscribed to.",
  ifYouAreMemberOfABoard: "If you are a member of a board:",
  manageMembers: "Manage members",
  manageWhoHasAccess: "Manage who has access to this workspace",
  active: "Active",
  suspended: "Suspended",
  inviteMembers: "Invite members",
  inviteToWorkspace: "Invite people to the %{workspaceName} workspace",
  emailAddress: "Email address",
  inviteAs: "Invite as",
  teamMembers: "Team members",
  gitHubConnected: "GitHub successfully connected",
  nothingToShow: "Nothing to show here",
  findTagsOrCreateNew: "Find tags or create new",
  deleteTag: "Delete tag",
  addNewBoardOrPage: "Add new board or page",
  spaceSettings: "Space settings",
  rename: "Rename",
  changeIcon: "Change icon",
  addToFavorites: "Add to favourites",
  removeFromFavorites: "Remove from favourites",
  viewmoreassignees: "View more assignees",
  noassignee: "No assignee",
  currentuser: "Current user",
  aPrivateSpace: "a private space",
  areYouSureYouWantToRemove: "Are you sure you want to remove them? They will lose access to this workspace.",
  areYouSureYouWantToLeave: "Are you sure you want to leave this workspace? You will need an invite to regain access.",
  youAreTheOnlyPersonInThisPrivateSpace: "You are the only person in this private space. If you leave, no-one will be able to access it. If your organisation still needs access, invite someone before you leave.",
  whenYouLeaveAPrivateSpace: "When you leave a private space, you’ll no longer be able to see any of its boards or pages. To rejoin, you’ll need to be invited again.",
  youCanRejoinThePublicSpace: "You can rejoin the space from the spaces screen.",
  areYouSureYouWantToRevoke: "Are you sure you want to revoke their invite to this workspace?",
  areYouSureYouWantToTransferOwnership: "Are you sure you want to transfer ownership of this workspace? Only the new owner will be able to undo this.",
  transferOwnership: "Transfer ownership",
  transferSpaceOwnershipConfirmed: "Space ownership transferred",
  transferSpaceOwnershipShort: "You must transfer ownership before you can leave",
  transferSpaceOwnershipDescription: "If you make %{name} the owner of this space, you will no longer be the owner and will be changed to a member.",
  transferSpaceOwnershipBeforeLeaving: "You must make someone else the owner of this space before you can leave it. Go to the space settings to make someone else the owner.",
  confirm: "Confirm",
  revoke: "Revoke",
  notFound: "Not found",
  itemNotFound: "Item not found",
  urlDoesntLeadAnywhere: "That URL doesn’t lead anywhere",
  itemMightBeDeleted: "The item might have been deleted, or you might not have access",
  deleteItem: "Delete %{item}",
  deleteSpace: "Delete space",
  ifYouWantToDeleteSpace: "If you want to delete this space, type its name below.",
  ifYouWantToDeleteResource: "If you want to delete this %{resourceType}, type its name below.",
  ifYouWantToArchiveResource: "If you want to archive this %{resourceType}, type its name below.",
  typeTheNameOfTheSpace: "Type the name of the space",
  removeMember: "Remove member",
  leaveWorkspace: "Leave workspace",
  revokeInvite: "Revoke invite",
  invited: "Invited",
  pending: "Pending",
  admin: "Admin",
  owner: "Owner",
  guest: "Guest",
  inviteSent: "Invite sent",
  resendInvite: "Resend invite",
  whatsNew: "What’s new",
  viewUpdates: "View updates in our weekly changelog",
  whenYouCreateTags: "When you create tags from a card, they’re saved as tags for that space only. Create common tags (e.g. bug) here to make them available in all spaces. If any space-level tags exist with the same name we’ll merge them into the workspace tag.",
  merge: "Merge",
  theSpace: "The space",
  haveSameTags: "have tags with the same name.",
  doYouWantToMerge: "Do you want to merge these into the new workspace tag?",
  tagWithThisNameWorkspace: "A workspace tag with this name already exists",
  tagWithThisNameSpace: "A tag with this name already exists in the space",
  editTag: "Edit tag",
  workspaceTags: "Workspace Tags",
  manageTags: "Manage tags that are shared across all spaces",
  youCantUndo: "You can’t undo this action.",
  merge2spaceTags: "With the same name into the workspace tag?",
  areYouSureYouWantToDelete: "Are you sure you want to delete the “%{resourceTitle}” %{resourceType}?",
  uploaded: "Uploaded",
  cardCreatedInResource: "Card created in '%{resourceName}' %{resourceType}",
  ["global.label.createIn"]: "Create in",
  rememberBoard: "Remember board",
  cardTitle: "Card title",
  pageTitle: "Page title",
  cardDescription: "Card description...",
  editAsignees: "Edit asignees",
  actionFailed: "Action failed",
  thisBoardIsEmpty: "This board is empty. Please create a list first.",
  changesAreSavedAuto: "Changes saved automatically",
  untitledCard: "Untitled card",
  editAssignees: "Edit assignees",
  showChildCards: "Show child cards",
  hideChildCards: "Hide child cards",
  createAndManageSpaces: "Create and manage spaces",
  thereAreNoListInBoard: "There are no lists in board.",
  pageMovedToParent: "Page moved to parent",
  subscribedToResourceUpdates: "Subscribed to %{name} updates",
  unsubscribedFromResourceUpdates: "Unsubscribed from %{name} updates",
  subscribingToResourceUpdatesFailed: "Failed to subscribe to %{name} updates",
  unsubscribingFromResourceUpdatesFailed: "Failed to unsubscribe from %{name} updates",
  couldntArchiveCard: "Couldn’t archive card.",
  cardRestored: "Card is restored",
  dueOn: "Due on",
  today: "Today",
  yesterday: "Yesterday",
  attached: "attached",
  removed: "removed",
  updatedTheStartDate: "updated the start date to",
  setTheStartDate: "set the start date to",
  removedStartDate: "removed start date",
  updatedTheDueDate: "updated the due date to",
  setTheDueDate: "set the due date to",
  removedDueDate: "removed due date",
  changedStausFrom: "changed status from",
  editStatus: "Edit status",
  editName: "Edit name",
  numberOfCards: "Number of cards",
  createdCard: "created card",
  createdEpic: "created project",
  people: "people",
  assignedMember: "assigned",
  archivedTheCard: "archived the card",
  restoredTheCard: "restored the card",
  archivedTheEpic: "archived the project",
  restoredTheEpic: "restored the project",
  theCardDescription: "the card description",
  theCardTitle: "the card title",
  theEpicDescription: "the project description",
  theEpicTitle: "the project title",
  ["quickPage.title.attachImageFrom"]: "Attach image from...",
  ["quickPage.title.attachCoverImageFrom"]: "Attach cover image from...",
  chooseWorkspaceToConnectIntegration: "Choose a workspace to connect with %{integrationName}",
  connectSuperthreadWith: "Connect Superthread with %{integrationName}",
  zapierIntegradionDescripiton: "Zapier lets you to build custom workflows that connect Superthread with almost any other app: Typeform, Gmail, Intercom, Google Forms, Zendesk, Airtable, Front, and many more.",
  connectToZapier: "Connect Zapier to Superthread",
  zapier: "Zapier",
  openZapier: "Open Zapier",
  allow: "Allow",
  integrationWillHave: "%{integrationName} will have read and write access to cards, boards, and pages in your workspace.",
  youMayBeSharing: "You may be sharing sensitive info with this site or app. You can always see or remove access in your",
  stSettings: "Superthread settings",
  seeIntegration: "See %{integrationName}’s",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  makeSureYouTrust: "Make sure you trust %{integrationName}",
  integrationIsRequesting: "%{integrationName} is requesting access to the",
  previewStInSlack: "Preview Superthread links in Slack",
  lookingForSlackNotifications: "Looking for Slack notifications?",
  turnThemOnInYour: "Turn them on in your",
  notificationsSettings: "Notifications settings",
  connectToSlack: "Connect to Slack to see key information from Superthread cards and pages when links are included in Slack messages.",
  orLc: "or",
  useBoardsToVisualise: "Use boards to visualise your workflow, track your team’s progress, and plan what to do next. Create multiple boards to keep things organised.",
  collaborativeDocuments: "Collaborative documents with text, images, markdown, and inline comments. Take notes, write specs, build a wiki, or share information publicly.",
  filterAcrossTheEntire: "Filter across the whole workspace to create a view of all cards assigned to you, or perhaps create a global bugs backlog. Views can be private or shared with your team.",
  useFiltersToCreate: "Use filters to create custom views of only the cards you want to see",
  kanbanBoardsUc: "Kanban boards",
  importYourExistingTasksFrom: "Import your existing tasks from",
  importTasks: "Import tasks",
  leaveSpace: "Leave space",
  viewSpace: "View space",
  deleted: "%{name} deleted",
  leaveNamedSpace: "Leave %{name} space?",
  leaveNamedPrivateSpace: "Leave %{name} private space?",
  deleteAndLeaveNamedPrivateSpace: "Delete and leave %{name} private space?",
  youLeftNamedSpace: "You left the %{name} space.",
  youCannotLeaveTheSpace: "You cannot leave this space",
  joinSpace: "Join space",
  joinThisSpace: "Join this space",
  hasUnsupportedFileType: "has unsupported file type",
  maxAllowedImageSize: "Maximum allowed image size is",
  maxAllowedImageResolution: "Max. allowed image resolution is",
  movedFromSpace: "moved from space",
  untitledPage: "Untitled page",
  hideChildPages: "Hide subpages",
  showSubpages: "Show subpages",
  addedTo: "added to",
  addMembers: "Add members...",
  removedFrom: "removed from",
  viewMembers: "View members",
  enableScrollFocus: "Show current item in sidebar",
  copyLinkToHeading: "Copy link to heading",
  joined: "Joined",
  addOwner: "Add owner",
  noOwner: "No owner",
  setOwner: "Set owner",
  font: "Font",
  addNewFolder: "Create folder",
  deletedSuccesfully: "removed from favourites",
  addedSuccesfully: "added to favourites",
  clickToUpdate: "Click to update",
  NewVersionAvailable: "A new version of the app is available",
  addedChildCard: "added child card",
  removedChildCard: "removed child card",
  removedChecklist: "removed checklist",
  addedChecklist: "created checklist",
  addedChecklists: "created checklists",
  markedAsIncomplete: "marked as incomplete",
  completedChecklistItem: "completed",
  addedParentCard: "added parent card",
  removedParentCard: "removed parent card",
  changedParentCardFrom: "changed parent card from",
  deleteFolder: "Delete folder",
  renameFolder: "Rename folder",
  lockSidebar: "Keep the sidebar open",
  hideSidebar: "Hide sidebar",
  appearance: "Appearance",
  changeHowSuperthreadLooksAndFeels: "Change how Superthread looks and feels",
  matchSistemSettings: "Match system settings",
  darkMode: "Dark mode",
  lightMode: "Light mode",
  darkGreyMode: "Dark grey mode",
  darkBlueMode: "Dark blue mode",
  lightBlueMode: "Light blue mode",
  year: "Year",
  quarter: "Quarter",
  month: "Month",
  addNewPageInside: "Add subpage",
  addChildPage: "Add subpage",
  theme: "Theme",
  boardSettings: "Board settings",
  reaction: "Reaction",
  inbox: "Inbox",
  resolve: "Resolve",
  unresolved: "Unresolved",
  unresolve: "Unresolve",
  unresolvedOnly: "Unresolved only",
  resolved: "Resolved",
  unresolveComment: "Unresolve comment",
  resolveComment: "Resolve comment",
  commentResolved: "Comment resolved",
  commentUnresolved: "Comment unresolved",
  resolvedOnly: "Resolved only",
  allComments: "All comments",
  noUnresolvedComments: "No unresolved comments",
  noResolvedComments: "No resolved comments",
  noComments: "No comments",
  about: "About",
  markAsRead: "Mark as read",
  markAsUnread: "Mark as unread",
  markAllAsResolved: "Mark all as resolved",
  showUnresolved: "Show unresolved",
  showResolved: "Show resolved",
  noNotifications: "No notifications",
  noNewNotifications: "No new notifications",
  noUnresolvedNotifications: "No unresolved notifications",
  youCanShow: "You can show",
  notificationsInstead: "notifications instead",
  subscribeToGetNotifications: "Subscribe to something and you’ll be notified of activity",
  selectANotificationToViewIt: "Select a notification to view it",
  youCanMarkANotificationAs: "You can mark a notification as",
  unreadOr: "unread or",
  resolveIt: "resolve it",
  inboxNotificationsAreUnresolved: "Notifications are unresolved until you resolve them",
  notificationsAreNew: "Notifications are new if you haven’t seen them before",
  wantNotificationsIn: "Want notifications in",
  slaskQuestionMarkVisit: "Slack? Visit",
  noCardsMatchChosenFilter: "There are no cards that match the chosen filters",
  noCardsFound: "No cards found",
  boardMoved: "Board moved",
  pageMoved: "Page moved",
  openPage: "Open page",
  hasBeenDeleted: "has been deleted",
  deletedResourcePlain: "This resource has been deleted.",
  deletedResourceWithName: "This %{name} has been deleted.",
  this: "This",
  andTheEntire: "and the entire",
  reactionsToYourComments: "Reactions to your comments",
  youWereRemoved: "You were removed",
  fromPrivateSpace: "from a private space",
  privateSpaceDesc: "This space is private so you cannot see its name or contents",
  privateSpace: "Private space",
  everything: "Everything",
  taskIsOverdue: "Task is overdue",
  endDateIsBeforeStartDate: "End date is before start date",
  moveCardIntoBoard: "Card moved to board",
  inList: "in list",
  searchForParentCard: "Search for parent card",
  icons: "Icons",
  emojis: "Emojis",
  custom: "Custom",
  moveToBoard: "Move to board",
  previous: "Previous",
  manualOrder: "Manual order",
  sortedBy: "Sorted by",
  toCancelDrag: "to cancel drag",
  groupBy: "Group by",
  subpageCreated: "Subpage created",
  tableOfContents: "Table of contents",
  editWorkspaceTagsInSettings: "Edit workspace tags in settings",
  sideDocked: "Side docked",
  modalOverlay: "Modal overlay",
  cardLayout: "Card layout",
  switchLayout: "Switch layout",
  showSidebar: "Show sidebar",
  notags: "No tags",
  resetLayoutToBoardDefault: "Reset layout to board default",
  alreadyOpen: "%{resource} already open",
  defaultBoardLayout: "Default board layout",
  defaultBoardLayoutDescription: "Everyone will see this layout by default. This setting can be changed later.",
  boardDescription: "Cards are grouped into columns",
  listDescription: "Cards are in a vertical list, split into groups",
  timelineDescription: "A timeline based on start and due dates",
  calendarDescription: "Cards are placed on their due date",
  boardName: "Board name",
  memberRemoved: "Member removed",
  resetLayoutToViewDefault: "Reset order to default",
  earliestDueDate: "Earliest due date",
  highestPriority: "Highest priority",
  largestEstimate: "Largest estimate",
  STIsMostUseful: "Superthread is most useful when you work with others.",
  readOnly: "Read only",
  boardWillNotShowOnPublicPage: "This board will not show on the public page",
  removeBoard: "Remove board",
  noSprints: "Sprints will be listed here from latest to earliest",
  noNonSprintBoardsInThisSpace: "No non-sprint boards in this space",
  inviteToWorkspaceDescription: "To add existing members to a space, go to space settings",
  alreadyMembersOfWorkspace: "Some people are already in the workspace. They’ll be added to any relevant spaces chosen below.",
  information: "Information",
  success: "Success",
  error: "Error",
  warning: "Warning",
  typeSomething: "Type something...",
  invite: "Invite",
  latest: "Latest",
  cardChildrenTitle: "Child cards",
  childCards: "Child cards",
  members: "Members",
  removeFromCard: "Remove from card",
  displayName: "Display name",
  firstName: "First name",
  lastName: "Last name",
  update: "Update",
  openSuperthread: "Open Superthread",
  infoNotification: "Info notification",
  errorNotification: "Error notification",
  alertNotification: "Alert notification",
  successNotification: "Success notification",
  SignInIntoExistingWorkspace: "Sign in to existing workspace",
  preferences: "Preferences",
  pages: "Pages",
  gridView: "Grid view",
  listView: "List view",
  lastCreated: "Last created",
  lastUpdated: "Last updated",
  searchMembers: "Search members",
  or: "Or",
  add_collaborators: "Add Collaborators",
  selectWorkspace: "Select a workspace",
  selectWorkspaceIntegrations: "Select a workspace for integration",
  change: "Change",
  createNewWorkspace: "Create new workspace",
  notSeeingYourWorkspace: "Don’t see your workspace? Try a different email:",
  dismiss: "Dismiss",
  load: "Load",
  youAlreadyHave: "You already have",
  openBoard: "Open board",
  cardCannotBeMovedDirectlyToSpace: "Card cannot be moved directly into space.",
  clickToRename: "Click to rename",
  info: "Info",
  clearAllFilters: "Clear all filters",
  is: "is",
  is_not: "is not",
  includes: "includes",
  excludes: "excludes",
  fullscreen: "Full screen",
  commentsActivity: "Comments & activity",
  show: "Show",
  newestFirst: "Newest first",
  oldestFirst: "Oldest first",
  pageCreated: "Page created",
  ["quickPage.label.setAsDefaultSpace"]: "Set as default space",
  createNewList: "Create new list",
  enterListName: "Enter list name",
  listStatus: "List status",
  print: "Print",
  reactedWith: "reacted with",
  you: "you",
  cannotModidyListStatus: "Cannot modify list status when there are %{resourceType} added",
  onlineAgain: "You’re back online",
  youAreOffline: "You’re offline",
  exploring: "Exploring",
  deactivated: "deactivated",
  deleteView: "Delete view",
  saveAsNewView: "Save as new view",
  noResults: "No results",
  thisFilterDoesNotMatch: "This filter does not match any cards",
  rememberChoice: "Remember choice",
  electronOpenInApp: "Open in app",
  electronOpenInDesktopApp: "Open in desktop app",
  electronOpenLinksInDesktopApp: "Open links in desktop app",
  electronAutoOpenLinksInDesktopApp: "Automatically open Superthread links in the desktop app",
  electronCurrentLinkOpenedInApp: "Current link was opened in the desktop app",
  electronAppIsInstalled: "It looks like you have the app installed",
  electronUserMentioned: "mentioned you",
  electronResourceMoved: "moved a",
  electronMemberAdded: "added you to a",
  electronMemberRemoved: "removed you from a",
  electronCommentAdded: "added a new comment",
  electronResourceArchived: "archived a",
  electronUserReacted: "reacted:",
  results: "Results",
  tasks: "Tasks",
  updateAppToEditPage: "Please update the app to edit this page",
  electronRecentlyViewed: "Recently viewed",
  electronOpenDesktopApp: "Open desktop app",
  electronRedirectingToApp: "Redirecting to desktop app...",
  updateAppToEditComment: "Please update the app to edit this comment",
  updateAppToEditCard: "Please update the app to edit this card",
  connectToImporter: "Connect to %{importerName}",
  accessToken: "access token",
  installationCloudHostname: "installation / cloud hostname",
  findInYour: "Find in your",
  emailAddressYouUseFor: "Email address used for your %{importerName} account",
  selectWhich: "Select which",
  selectBoardsToImport: "Select %{boardEq} you want to import %{cardEq} from",
  importYourExistingNameToST: "Import your existing %{importerName} %{boardEq} to Superthread",
  jiraBoardMapingSubtitle: "Select which boards you want to import from Jira.",
  trelloBoardMapingSubtitle: "Select which boards you want to import from Trello.",
  shortcutBoardMapingSubtitle: "Select the teams and workflows to import stories from.",
  jiraQuickImportText: "All teams will be imported into a space called ‘jira-import’. You can easily rename and reorganise your boards from there.",
  trelloQuickImportText: "All teams will be imported into a space called ‘trello-import’. You can easily rename and reorganise your boards from there.",
  shortcutQuickImportText: "Each ‘team-workflow’ board will be imported into a space called ‘shortcut-import’. You can easily rename and reorganise your boards from there.",
  jiraCustomImportText: "Choose which boards to import, and which spaces they should be imported to.",
  trelloCustomImportText: "Choose which boards to import, and which spaces they should be imported to.",
  shortcutCustomImportText: "Choose which ‘team-workflow’ boards to import, and which spaces they should be imported to.",
  superthreadSpace: "Superthread space",
  mapImporterUsersToSTUSers: "Map %{importerName} users to Superthread users (or invite missing ones) to preserve card members, creators, and activity.",
  startImport: "Start import",
  wellLetYouKnowWhenImportFinishes: "We’ll let you know when the import finishes",
  feelFreeToContuinueUsingST: "Feel free to continue using Superthread",
  dontImportThisUser: "Don’t import this user",
  matchToAnExistingSTUser: "Match to an existing Superthread user",
  createANewUser: "Create a new user (email invite)",
  projectsCannotBeMovedToSpaces: "Projects cannot be moved to spaces",
  // importEpics: "Import epics",
  // importEpicsDesc:
  //   "Epics will be imported in their own separate Superthread board called ‘Epics’.",
  importOpenStories: "Import open stories",
  importOpenStoriesDesc: "Unresolved or opened stories will be imported with thier existing states.",
  importStaleStories: "Import stale stories",
  importStaleStoriesDesc: "Stories that haven’t been opened in over 6 moneths are considered stale. They will be imported to the archive and can be unarchived later.",
  wedLikeToTake: "We’d like to take",
  thirtySeconds: "30 seconds",
  toShowYouAround: "to show you around",
  getStarted: "Get started",
  youCanAlways: "You can always re-visit this tutorial from the help section in the sidebar",
  youreGoodToGo: "You’re good to go.",
  quickStart: "Quick start tutorial",
  getToKnow: "Get to know Superthread in 30 seconds",
  desktopApp: "Desktop app",
  thisLinkWasOpenedInApp: "This link was opened in the desktop app",
  openHereInstead: "Open here instead",
  browseAndManageSpaces: "Browse and manage spaces",
  manageSpaces: "Manage spaces",
  searchSpaces: "Search spaces",
  createSpace: "Create space",
  addADescription: "Add a description",
  showingNumberOfSpaces: "Showing %{num} result out of %{totalNum} total spaces",
  noResultsFoundFor: 'No results found for "%{query}"',
  changeDescription: "Change description",
  contents: "Contents",
  createSpaceSubtitle: "Spaces contain related boards, tasks, and pages. You might have a space per team, or per business area.",
  spaceNameAndIcon: "Space name and icon",
  somethingShortAndClear: "Something short and clear",
  youCanChangeThisLater: "You can change this later",
  descritionOptional: "Description (optional)",
  whatIsThisSpaceFor: "What is this space for?",
  addPeopleToSpaceOptional: "Add people to this space (optional)",
  addPeople: "Add people",
  addPeopleSubtitle: "If you invite people who are not part of the %{workspaceName} workspace, they’ll be added to it.",
  openSpace: "Open space",
  openSpaceSubtitle: "All members of your workspace can browse and join open spaces",
  privateSpaceSubtitle: "Workspace members cannot see or join private spaces unless they are invited by an existing member",
  inviteNewPeople: "Invite new people",
  inviteeEmailAddress: "Invitee email address",
  inviteSectionSubtitle: "They’ll be invited to the whole workspace, not just this space.",
  couldntCreateSpace: "Space could not be created, please try again.",
  spaceCreated: "Space created.",
  emailAlreadyAdded: "Email already added",
  addingSomeMembersFailed: "Failed to add some members",
  founder: "Founder",
  director: "Director",
  teamLead: "Team lead",
  individualContributor: "Individual contributor",
  softwareEngineering: "Software engineering",
  design: "Design",
  productManagement: "Product management",
  marketing: "Marketing",
  finance: "Finance",
  development: "Development",
  marketer: "Marketer",
  sales: "Sales",
  clickToView: "Click to view",
  clickToDownload: "Click to download",
  business: "Business",
  pickAllThatApply: "Pick all that apply",
  pickOne: "Pick one",
  customerSupport: "Customer support",
  humanResources: "Human resources",
  socialMedia: "Social media",
  wordOfMouth: "Word of mouth",
  searchEngine: "Search engine",
  advertising: "Advertising",
  searchForSpaceOrBoard: "Search for space or board",
  starTypingToSearchFor: "Start typing to search for",
  ["my-work"]: "My work",
  ["myWork.assigned"]: "Assigned to %{userName}",
  ["myWork.created"]: "Created by %{userName}",
  ["myWork.notes"]: "Notes",
  ["myWorkNoResults.created"]: "There are no cards created by you",
  ["myWorkNoResults.assigned"]: "There are no cards assigned to you",
  ["memberNoResults.assigned"]: "There are no cards assigned to %{userName}",
  ["memberNoResults.created"]: "There are no cards created by %{userName}",
  newCard: "New card",
  addedCommentHiddenByFilter: "Added comment is hidden by filter",
  createdCardHiddenByFilter: "Created card may be hidden by filter",
  viewWork: "View work",
  removeFromSpace: "Remove from space",
  assignedInThisBoard: "Assigned in this board",
  layout: "Layout",
  createdCardMovedSortOrder: "Created card may be moved by sort order",
  createCardGroupBy: "Card added to %{list}.",
  canNotMoveCardInsameBoard: "Can not move card in same board.",
  latestReply: "Latest reply",
  replyLabel: "Reply",
  totalReplies: "total replies",
  olderReplies: "older replies",
  leaveReply: "Leave a reply...",
  hideReplies: "Hide replies",
  showReplies: "Show replies",
  oneReply: "reply",
  discardComment: "Discard comment?",
  areYouSureYouWantToDiscard: "Are you sure you want to discard your comment?",
  skipToEnd: "Skip to end",
  priority: "Priority",
  noPriority: "No priority",
  urgent: "Urgent",
  high: "High",
  medium: "Medium",
  low: "Low",
  priorities: "Priorities",
  changedThePriorityFrom: "changed the priority from",
  changedTheEstimateFrom: "changed the estimate from",
  setThePriorityTo: "set the priority to",
  setTheEstimateTo: "set the estimate to",
  removedTheEstimate: "removed the estimate",
  thereAreNoPages: "There are no pages in this space.",
  createNewPageOrDrag: "Create a new page, or drag an existing page into this space in the sidebar.",
  thereAreNoBoards: "There are no boards in this space.",
  createNewBoardOrDrag: "Create a new board, or drag an existing board into this space in the sidebar.",
  commentsOnly: "Comments only",
  activityOnly: "Activity only",
  seeCardsWithThisTag: "See cards with this tag (count includes cards that might not show elsewhere)",
  noResultsForThatName: "No results for that name",
  youCan: "You can",
  createASpace: "create a space",
  named: 'named "%{query}"',
  estimate: "Estimate",
  onePoint: "1 point",
  numberOfPoints: "%{num} points",
  extraSmall: "Extra small",
  small: "Small",
  mediumSize: "Medium",
  large: "Large",
  extraLarge: "Extra large",
  noEstimate: "No estimate",
  settingsProjectsPreferencesSubtitle: "These settings will affect all members of the space",
  howCardsAreEstimated: "How cards are estimated in this space",
  disableCardEstimationForThisSpace: "Disable card estimation for this space",
  fibonacciPoints: "Fibbonaci points",
  exponentialPoints: "Exponential points",
  tshirtSizes: "T-shirt sizes",
  setEstimate: "Set estimate",
  emailNotificationHelperText: "An email every weekday with notifications you haven’t seen since the last email",
  estimated: "estimated",
  cardSpaceEstimationTurnedOff: "This card belongs to a space with estimation turned off",
  totalEstimatePointsTooltipContent: "%{totalPoints} estimated across %{numOfCards}",
  estimates: "estimates",
  assignItTo: "assign it to",
  searchForACard: "Search for a card",
  createACard: "Create a card",
  archivedCardsAreHidden: "archived cards are hidden",
  enterANameAbove: "Enter a name above",
  chooseFiltersYouWouldLike: "Then choose the filters you’d like in the filter bar",
  cannotCreateViewOnMobile: "You cannot create a view on mobile.",
  viewCardInBoard: "View card in its own board",
  guestsMustBeAddedToOneSpace: "Guests must be added to at least one space",
  createCard: "Create card",
  suggestedBasedOnTitle: "Suggested based on title",
  acceptSuggestion: "Accept suggestion",
  rejectSuggestion: "Reject suggestion",
  suggestionPlaceholderText: "Suggestion...",
  changeEmail: "Change email",
  logOutAndContinue: "Log out and continue",
  confirmAccountOwnership: "Confirm account ownership",
  reauthenticateEmailDescription: "To keep your account secure, we need you to log in again. Then you’ll be able to choose a new email address and complete the process.",
  enterANewEmail: "Enter a new email address:",
  resendLoginCode: "Resend login code",
  emailAddressTakenByAnotherUser: "Email address used by another user",
  assistant: "Assistant",
  changeTone: "Change tone",
  simplify: "Simplify",
  summarize: "Summarise",
  translate: "Translate",
  generate: "Generate",
  replaceText: "Replace text",
  insertBelow: "Insert below",
  assistanceWith: "What do you need assistance with?",
  copiedToClipboard: "Copied to clipboard",
  academic: "Academic",
  casual: "Casual",
  confident: "Confident",
  friendly: "Friendly",
  neutral: "Neutral",
  professional: "Professional",
  aiFeatures: "AI features",
  emailDigestSentAt: "Email digest at",
  inYourTimezone: "in your timezone (%{timezone})",
  timezone: "Timezone",
  setAutomatically: "Set automatically",
  searchTimezone: "Search timezone",
  changeYourTimezoneInProfile: "Change your timezone in profile.",
  enableNotificationsFirst: "Enable %{type} notifications first",
  turnOnAIAssitantInFormatingToolbar: "Turn on AI assistant in the text formatting toolbar",
  superthreadSendingDataTo: "Note that if you enable this for your workspace you consent to Superthread sending data to",
  experimentalFeatureMayChangeFunctionality: "This experimental feature may be subject to change in functionality and pricing.",
  contactUsToEnable: "Contact us to enable this feature.",
  boardOpenedInTheBackground: "%{boardTitle} board opened in the background",
  resetFilters: "Reset filters",
  ["create_space.title"]: "Create a space",
  ["create_space.tooltip"]: "Create a home for your team’s work",
  ["create_private_space.title"]: "Create a private space",
  ["create_private_space.tooltip"]: "Only people you invite can see a private space",
  ["invite_user.title"]: "Invite someone else",
  ["invite_user.tooltip"]: "Invite your team-mates to the workspace so they can track their work",
  ["mention_anything.title"]: "Mention something",
  ["mention_anything.tooltip"]: "Use the @ key to mention something, anywhere you can write",
  ["add_child_card.title"]: "Add a child card",
  ["add_child_card.tooltip"]: "Child cards help you break work down into smaller tasks",
  ["visit_inbox.title"]: "Check your inbox",
  ["visit_inbox.tooltip"]: "Keep track of everything you’re subscribed to in the inbox",
  ["move_page.title"]: "Move a page",
  ["move_page.tooltip"]: "Drag a page in the sidebar to move it wherever you want it",
  ["create_subpage.title"]: "Create a subpage",
  ["create_subpage.tooltip"]: "Subpages live inside other pages and help you structure your documents",
  ["add_page_icon.title"]: "Add a page icon",
  ["add_page_icon.tooltip"]: "A page icon helps you find the page again in search and the sidebar",
  ["add_page_cover.title"]: "Add a page cover image",
  ["add_page_cover.tooltip"]: "Set the tone for a page with a cover image",
  ["quick_card_shortcut.title"]: "Quick card shortcut (C)",
  ["quick_card_shortcut.tooltip"]: "Tap the C key anywhere to create a card",
  ["quick_page_shortcut.title"]: "Quick page shortcut (P)",
  ["quick_page_shortcut.tooltip"]: "Tap the P key anywhere to create a page",
  ["create_card.title"]: "Create a card",
  ["create_card.tooltip"]: "Create a card for each task you want to track",
  ["comment_on_card.title"]: "Comment on a card",
  ["comment_on_card.tooltip"]: "Write updates or note down your thoughts on a card",
  ["search_shortcut.title"]: "Find something with ⌘+K",
  ["search_shortcut.tooltip"]: "Quickly open universal search anywhere with this shortcut",
  ["create_board.title"]: "Create a board",
  ["create_board.tooltip"]: "Track the work of a sub-team or project",
  ["upload_avatar.title"]: "Upload avatar",
  ["upload_avatar.tooltip"]: "Help people recognise you around the app",
  ["create_page.title"]: "Create a page",
  ["create_page.tooltip"]: "Capture knowledge and thoughts with pages",
  ["set_your_name.title"]: "Set your name",
  ["set_your_name.tooltip"]: "Your name will be used throughout the app",
  aCardMustHaveATitle: "A card must have a title",
  showAll: "Show all",
  showLess: "Show less",
  hideEmptyGroups: "Hide empty groups",
  showAnotherAssignee: "Show another assignee",
  showAnotherTags: "Show another tags",
  spaceMembers: "Space members",
  addExistingMembers: "Add existing members",
  inviteNewMembers: "Invite new members",
  spaceDetails: "Space details",
  makeBoardFullWidth: "Make board full width",
  askAiAssistantSearch: "Ask AI based on your cards, pages, and notes",
  backToSearchResults: "Back to search results",
  sources: "Sources",
  askAiQuestionLong: "Question should have at least 10 characters.",
  spaceSprintsSettings: "%{space} space sprints settings",
  turnOnSprintsForThisSpace: "Turn on sprints for this space",
  turnOnSprintsDesc: "A “Sprints” section will be added to the sidebar for this space. A sprint is a board with a start and end date. When a sprint is completed, the next will start automatically.",
  ownersAdminsCanTurnOnSprints: "Only workspace owners, admins, and the space creator can change this setting",
  onlyOwnerOfPrivateSpace: "Only the owner of a private space can change this setting",
  onlySpaceOwnerCanModifyMembers: "Only owners can change space members",
  cannotModifySpaceOwner: "You cannot make changes to the owner of the space",
  sprintLength: "Sprint length",
  weeks: "weeks",
  sprintStartOn: "Sprints start on",
  coolDownPeriod: "Cool-down period between sprints",
  coolDownPeriodDesc: "A cool-down period will be added between each sprint. These are useful for e.g. retrospectives and clean-up activities.",
  coolDownPeriodLength: "Cool-down period length",
  sprintBoardStatuses: "Sprint board statuses",
  sprintBoardStatusesDesc: "Every sprint in this space uses the same statuses. You must have at least one of each status type. The “Backlog” status type is not available.",
  addStatus: "Add status",
  dueInDays: "Due in %{days} days",
  sprints: "Sprints",
  addSprint: "Add sprint",
  sprint: "Sprint",
  openSprint: "Open sprint",
  renameSprint: "Rename sprint",
  markAsComplete: "Mark as complete",
  changeSprintDates: "Change sprint dates",
  changeSprintDatesFor: "Change dates for %{sprintName}",
  cancelSprint: "Cancel sprint",
  changeDates: "Change dates",
  chooseNewStartAndEndDates: "Choose a new start or end date for %{sprintName}",
  renameSprintDescription: "Enter a new name for the sprint.",
  startDateIsEarlierThanPreviousEndDate: "Start date overlaps previous sprint’s end date",
  enterSprintName: "Enter sprint name",
  cancelSprintWarning: "All unfinished cards in this board will be moved into the cancelled status.",
  dontCancel: "Don’t cancel",
  upgradePlan: "Upgrade plan",
  upgradePrivateSpaceTitle: "Upgrade for private spaces",
  upgradePrivateSpaceDescription: "You can create private spaces on a paid plan.",
  upgradePlanBadgeTooltip: "Only the owner (%{spaceOwner}) and admins can change the workspace plan",
  upgradeUserRolesTitle: "Upgrade for user roles",
  upgradeUserRolesDescription: "You can choose non-admin user roles on a paid plan.",
  upgradedWorkspace: "Your workspace has been upgraded!",
  sprintSettings: "Sprint settings",
  electronDownloadApp: "Download the app",
  electronDownloadAppDescription: "We only support macOS. Let us know if there is demand for a Windows app.",
  macArm64Label: "Apple Silicon",
  macx64Label: "Apple Intel",
  mailCopiedToClipboard: "Email copied to clipboard",
  cardsWithNoSprint: "Cards with no sprint",
  showCardsFrom: "Show cards from",
  yourColor: "Your color",
  thisColorWillHelp: "This colour will help others identify you in some places.",
  logo: "Logo",
  prStateOpen: "%{count} open",
  prStateClosed: "%{count} closed",
  prStateMerged: "%{count} merged",
  invitingPeopleToWorkspace: "Only admins can invite new people to this workspace",
  upgradePublicPageIndexingTitle: "Upgrade for search engine indexing",
  upgradePublicPageIndexingDescription: "You can turn on search engine indexing on a paid plan.",
  shortcutWarningText: "Any Shortcut stories not assigned to a team will not be imported.",
  coolDown: "Cool-down",
  noBoardsOrPages: "No boards or pages",
  language: "Language",
  usersWork: "%{name}’s work",
  renameAttachment: "Rename attachment",
  deleteAttachment: "Delete attachment",
  timelineLayoutDescription: "Upgrade your workspace plan to use the timeline layout.",
  calendarLayoutDescription: "Upgrade your workspace plan to use the calendar layout.",
  upgradeTemplatesDescription: "Upgrade your workspace plan to use templates.",
  upgradeRoadmapAndProjectsDescription: "Upgrade your workspace plan to use roadmaps and projects.",
  upgradeViewsDescription: "Upgrade your workspace plan to save views.",
  createNewItem: "Create new item",
  statusType: "Status type",
  spaceLimitReached: "The space limit has been reached. You can delete some spaces to create more.",
  freePlanUsageLimits: "Free plan usage limits",
  item: "Item",
  usage: "Usage",
  limitReachedLong: "If a limit is reached, you will need to remove items or upgrade the plan before new items can be created.",
  limitReached: "Limit reached",
  resourceAndContentWillBeDeleted: 'The %{resourceType} "%{resourceTitle}" and its contents will be permanently deleted for everyone. This cannot be undone.',
  resourceWillBeDeleted: 'The %{resourceType} "%{resourceTitle}" will be permanently deleted for everyone. This cannot be undone.',
  epicWillBeDeleted: 'The %{resourceType} "%{resourceTitle}" will be permanently deleted. This cannot be undone. Any cards that have been added to the project will not be deleted.',
  listNameLabel: "List name",
  deleteList: "Delete list",
  itemName: "Item name",
  moveCardIntoSprint: "Card moved to sprint %{sprintName}",
  addView: "Add view",
  timeCreatedSort: "Time created",
  timeUpdatedSort: "Time updated",
  dueDateSort: "Due date",
  noSprintsLabel: "No sprints",
  createdViaEmailFrom: "created via email from",
  couldNotBeVerified: "Could not be verified",
  createCardsViaEmailTitle: "Create cards in this board via email",
  createCardsViaEmailDescription: "Create a card in this board if anyone sends a message to an email address.",
  onlyCurrentAddressWillWork: "Only the address currently shown will work.",
  regenerate: "Regenerate",
  emailCopiedToClipboard: "Email copied to clipboard",
  emailRegenerated: "Email regenerated",
  slackChannelNotifications: "Slack channel notifications",
  slackChannelNotificationsTitle: "Send notifications about cards in this board to a Slack channel",
  slackChannelNotificationsDescriptionDisabled: "A Slack window will open and ask you to choose a channel",
  slackChannelNotificationsDescriptionEnabled: "Notifications from this board are sent to %{channel} in Slack.",
  slackIntegrationError: "Could not enable Slack integration. Please try again",
  boardDoesNotExists: "That board doesn’t exist",
  boardActivity: "Board activity",
  sendTo: "Send to",
  slackPrivateMessage: "a private message",
  slackPrivateGroup: "a private conversation",
  slackPrivateChannel: "a private channel",
  webhookNotificationCardAddedBoard: "Card added/moved to board",
  webhookNotificationCardAddedList: "Card added/moved to status",
  webhookNotificationCardCommented: "Comment left on card in board (excluding replies)",
  webhookNotificationCardDueDate: "Card due date is soon/overdue",
  folder: "Folder",
  yourSpaces: "Your spaces",
  quoteReply: "Quote and reply",
  itemHasBeenDeleted: "%{resourceType} has been deleted",
  deletedNotification: "deleted",
  searchForBoard: "Search for board",
  activeSprintText: "Current",
  loadMoreSprints: "Load more sprints",
  try: "Try",
  ["add_workspace_logo.title"]: "Add a workspace logo",
  ["add_workspace_logo.tooltip"]: "Upload a logo",
  ["customise_your_profile.title"]: "Customise your profile",
  ["customise_your_profile.tooltip"]: "Add a profile photo",
  ["import_tasks.title"]: "Import tasks",
  ["import_tasks.tooltip"]: "Import from Trello, Jira, or Shortcut",
  ["view_keyboard_shortcuts.title"]: "View keyboard shortcuts",
  ["view_keyboard_shortcuts.tooltip"]: "Open keyboard cheat sheet",
  ["connect_slack.title"]: "Connect Slack",
  ["connect_slack.tooltip"]: "Turn on Slack notifications",
  seeAllWorkspaces: "See all workspaces",
  workspaceSettings: "Workspace settings",
  switchToRecentWorkspace: "Switch to recent workspace",
  icon: "Icon",
  addToSprint: "Add to sprint",
  addToProject: "Add to project",
  goToProject: "Go to project",
  addTags: "Add tags",
  cancelled: "Cancelled",
  sprintBoards: "Sprint boards",
  sprintSettingsBoardsDescription: "These settings apply to all sprints in this space",
  addedCard: "Added card",
  removedCard: "Removed card",
  addNewCard: "Add new card",
  addExistingCard: "Add existing card",
  changeEpicOrParent: "Change project or parent",
  cardAlreadyHasEpicOrParent: "The chosen card already has a project or parent card. They will be changed if you add it to this project.",
  changeEpic: "Change project",
  childCardIsPartOfEpic: 'The child card is part of the project "%{epicName}".',
  parentCardHasNoEpic: "The parent card has no project.",
  parentCardIsPartOfEpic: 'The parent card is part of the project "%{epicName}".',
  childCardsEpicWillBeRemoved: "The child card’s project will be removed if you continue.",
  childCardsEpicWillChangeToParents: "The child card’s project will change to the parent card’s project if you continue.",
  removeEpic: "Remove project",
  epicWillNoLongerBeAssociated: 'The child card will no longer be associated with the project "%{epicName}" if you remove it from its parent card.',
  childCardAlreadyHasParent: "The child card already has a parent. The parent will be changed to this card if you continue.",
  cardsDirectlyAddedToEpicCantHaveParent: "Cards added directly to projects can’t have parent cards",
  epicNoTagsFound: "No tags found. Projects can only use workspace tags",
  cannotChangeStatusForCardsInFinishedSprint: "Cannot change status for cards in finished sprint",
  cannotChangeStatusForArchivedCards: "Cannot change status for archived cards",
  cantMoveArchivedCardToSprint: "Can’t move archived card to sprint",
  relatedTo: "Related to",
  changePriority: "Change priority",
  changeEstimate: "Change estimate",
  changeTags: "Change tags",
  changeSprint: "Change sprint",
  goToSprint: "Go to sprint",
  pastSprints: "Past sprints",
  currentAndPlannedSprints: "Current and planned sprints",
  seeAllSprints: "See all sprints",
  currentAndNextSprint: "Current and next sprint",
  branchSpecificAutomationAddFailed: "Failed to add new branch-specific automation.",
  branchSpecificAutomationUpdateFailed: "Failed to update branch-specific automation.",
  branchSpecificAutomationRemoveFailed: "Failed to remove branch-specific automation.",
  thereAreNoCurrentOrPlannedSprints: "There are no current or planned sprints",
  thereIsNoCurrentOrNextSprint: "There is no current or next sprint",
  movedCardFrom: "Moved card from",
  movedEpicFrom: "Moved project from",
  rolledCardFrom: "Rolled card from",
  sprintMarkedAsCompleted: "Sprint marked as completed",
  sprintMarkedAsCancelled: "Sprint marked as cancelled",
  cardIsParent: "Card is parent",
  cardIsChild: "Card is child",
  cardIsRelated: "Card is related",
  parentCard: "Parent card",
  moveTo: "Move to...",
  pageMovedTo: "Page moved to",
  thisSpaceIsEmpty: "This space is empty",
  createSomethingToGetStarted: "Create something to get started",
  visualiseYourWorkflow: "Visualise your workflow, track work, and keep things organised",
  captureImportantInformation: "Capture important information, collaborate with others, and share to the web",
  organiseWorkIntoSprints: "Organise work into stretches of time so you can plan more easily",
  filterYourWorkspaceToCreateViews: "Filter your workspace to create views, and share them with your team",
  turnOnSprints: "Turn on sprints",
  cardViews: "Card views",
  convert: "Convert",
  convertCardToEpic: "Convert card to project",
  couldNotConvertCardToEpic: "Couldn’t convert card to project",
  cardSuccessfullyConvertedToEpic: "Card successfully converted to project",
  convertedCardWillLose: "If you convert this card to a project, it will lose its %{arr, list}.",
  convertedThisCardToEpic: "converted this card to a project",
  spaceLevelTags: "space-level tags",
  effortEstimate: "effort estimate",
  existingEpic: "existing project",
  roadmapMustHaveAtLeastOneStatus: "The roadmap must have at least one status",
  chosenPageIsAlreadySubpage: "Chosen page is already a subpage of current page",
  searchForResults: "Search to show results",
  parentCardIs: "Parent card is...",
  projectIs: "Project is...",
  convertedTo: "converted to",
  moveToCompletedSprint: "Move to completed sprint?",
  onlyDoneCardsCanBeMovedToCompletedSprint: "Only “Done” cards can be moved to a completed sprint. This card will be changed to “Done” and moved.",
  removeCardFromProject: "Remove card from project",
  roadmapOpenedInTheBackground: "Roadmap opened in the background",
  unfavouriteCurrentSprint: "Unfavourite current sprint",
  favouriteCurrentSprint: "Favourite current sprint",
  unfavouriteNextSprint: "Unfavourite next sprint",
  favouriteNextSprint: "Favourite next sprint",
  unfavouriteSprintName: "Unfavourite %{sprintName}",
  favouriteSprintName: "Favourite %{sprintName}",
  currentSprint: "Current sprint",
  parentWillBeRemovedIfAddToProject: "The parent card will be removed if you add this card to a project, since cards inherit projects from parent cards",
  cannotArchiveCardFromSprint: "Cannot archive card from a sprint",
  sprintCompleted: "Sprint completed",
  sprintCancelled: "Sprint cancelled",
  sprintDatesChanged: "Sprint dates changed",
  myWorkAndNotes: "My work & notes",
  notes: "Notes",
  suggestedActions: "Suggested actions",
  noSuggestedActions: "No suggested actions",
  noChanges: "No changes",
  changes: "Changes",
  cardUpdatedSuccessfully: "Card updated successfully",
  commentAddedSuccessfully: "Comment added successfully",
  updateCard: "Update card",
  moveCard: "Move card",
  assignMembers: "Assign members",
  removeMembers: "Remove members",
  generatingSuggestedActions: "Generating suggested actions",
  replaceContent: "Replace content",
  appendContent: "Append content",
  addDescription: "Add description",
  addDueDate: "Add due date",
  setTitle: "Set title",
  reject: "Reject",
  accept: "Accept",
  finaliseDetails: "Finalise details",
  tidyUp: "Tidy up",
  convertTo: "Convert to...",
  newNote: "New note",
  searchNotes: "Search notes...",
  favouriteNote: "Favourite note",
  archiveNote: "Archive note",
  deleteNote: "Delete note",
  original: "Original",
  tidied: "Tidied",
  untitledNote: "Untitled note",
  enhanced: "Enhanced",
  minimize: "Minimize",
  maximize: "Maximize",
  createNewNote: "Create a new note",
  youDontHaveAnyNotes: "You don't have any notes yet",
  transcript: "Transcript",
  assignedCards: "Assigned cards",
  createdCards: "Created cards",
  noTranscriptAvailable: "No transcript available",
  enhanceNotesUsingMacApp: "Superthread can transcribe audio from your meetings to generate enhanced notes. Transcribing is only available in the Superthread desktop app for macOS.",
  downloadApp: "Download app",
  enhance: "Enhance",
  macIntel: "Mac Intel",
  appleSilicon: "Apple Silicon",
  enhanceNotesUsingAI: "Enhance your notes using AI",
  showTranscript: "Show transcript",
  epicCreated: "Project created",
  analysingTranscript: "Analysing transcript",
  comparingYourNotes: "Comparing your notes",
  readingYourNotes: "Reading your notes",
  enhancingYourNotes: "Enhancing your notes",
  finished: "Finished",
  note: "Note",
  epicMustHaveTitle: "A project must have a title",
  seeAllNotes: "See all notes",
  autoSaved: "Auto-saved",
  projectsAreTrackedOnRoadmap: "Projects are tracked on the roadmap",
  addCardsToProject: "Add cards to this project",
  projectEmptyStateDescription: "A project is a large piece of work comprised of many cards from across the workspace. Create a project in a column, or edit the default statuses.",
  cardInProjectEmptyStateFooter: "A card can only belong to one project",
  addCardsThatContributeToProject: "Add cards that contribute to this project. You can",
  noProject: "No project",
  noteTemplates: "Note templates",
  noteTemplatesSettingsSubtitle: "Quickly change the formatting of notes with templates",
  noNoteTemplates: "No note templates",
  createNoteTemplate: "Create note template",
  sections: "Sections",
  sectionHeading: "Section heading",
  sectionDescriptionPlaceholder: "This section should focus on...",
  addSection: "Add section",
  superthread: "Superthread",
  deletedTemplate: "Deleted template",
  autoEnhanced: "Auto-enhanced",
  meetingContext: "Meeting context",
  meetingContextPlaceholder: "Provide an overview of the meeting and what you want to get out of it...",
  meetingContextDescription: "This helps Superthread understand what to focus on when enhancing your notes",
  duplicateTemplate: "Duplicate template",
  favouriteTemplates: "Favourite templates",
  introduction: "Introduction",
  sampleSectionDescription: "Capture any interesting talking points from the small-talk at the start of the meeting. Ignore discussions about the weather.",
  allowSuperthreadToTranscribe: "Allow Superthread to transcribe your meetings",
  superthreadCanEnhance: "Superthread can enhance your notes by transcribing audio directly from your laptop, no meeting bots needed. It works for in-person and virtual meetings, with full control over when it’s on. Your audio is never stored or used for anything else.",
  transcribeYourVoice: "Transcribe your voice",
  transcribeOthersVoice: "Transcribe others' voice",
  allowMicrophoneCapture: "Allow microphone capture",
  allowSystemAudioCapture: "Allow system audio capture",
  microphoneAccessNotAllowedTitle: "Manually allow microphone access",
  microphoneAccessNotAllowedDesc1: "Microphone access was previously not allowed, so you will need to allow it manually.",
  microphoneAccessNotAllowedDesc2: "In macOS, go to System Settings > Privacy & Security > Microphone and allow the “Superthread” app.",
  microphoneAccessNotAllowedDesc3: "After you’ve done that, please quit and re-open this app, then return here.",
  systemAccessNotAllowedTitle: "Manually allow system audio access",
  systemAccessNotAllowedDesc1: "Microphone access was previously not allowed, so you will need to allow it manually.",
  systemAccessNotAllowedDesc2: "In macOS, go to System Settings > Privacy & Security > Microphone and allow the “Superthread” app.",
  systemAccessNotAllowedDesc3: "After you’ve done that, please quit and re-open this app, then return here.",
  editNoteTemplate: "Edit note template",
  viewNoteTemplate: "View note template",
  viewTranscript: "View transcript",
  transcribeHereInstead: "Transcribe here instead?",
  currentlyTranscribingAnotherNote: "The note “%{noteTitle}” is currently transcribing. Do you want to stop transcription there and transcribe here instead?",
  transcribeHere: "Transcribe here",
  resume: "Resume",
  pause: "Pause",
  transcribe: "Transcribe",
  currentlyTranscribing: "Currently transcribing",
  transcribingOnlyAvailableOnMac: "Transcribing is only available in the macOS app",
  startTranscription: "Start transcription",
  stopTranscription: "Stop transcription",
  openTranscribingNote: "Open transcribing note",
  notesSettings: "Notes settings",
  theseSettingsArePersonalToYou: "These settings are personal to you",
  transcriptionJargonTitle: "Jargon",
  transcriptionJargonPlaceholder: "Tehnical terms, uncommon names, project names, etc.",
  transcriptionJargonDescription: "Add any words you think audio transcription might have a problem with. Separate words with commas.",
  selectANote: "Select a note",
  noteDoesntExist: "Note doesn't exist",
  deleteSection: "Delete section",
  untitledSection: "Untitled section",
  messageAgentAssistant: "Message agent assistant",
  initialAgentMessage: "I'm here to help you write instructions for your agent. Let me know what do you want it to do.",
  agentMessageError: "An error occurred. Please try again.",
  agentInstructions: "Agent instructions",
  version: "Version",
  templateWithChildCardsNotAllowed: "You can only apply a template to a child card if the template has none of its own children",
  copyNoteToClipboard: "Copy note to clipboard",
  noteCopiedToClipboard: "Note copied to clipboard",
  copyTranscriptToClipboard: "Copy transcript to clipboard",
  transcriptCopiedToClipboard: "Transcript copied to clipboard",
  anyoneWithThisLinkCanViewNote: "Anyone with this link can view the note",
  notesEnhancedBySuperthread: "Notes enhanced by Superthread",
  connectGoogleCalendar: "Connect Google Calendar",
  googleCalendarIntegration: "Google calendar integration",
  googleCalendarIntegrationSubtitle: "Connect to your Google Calendar to easily create notes for upcoming meetings",
  calendarAccountConnected: "Calendar account connected",
  disconnect: "Disconnect",
  showCalendarMeetingsUpTo: "Show calendar meetings up to",
  dayAheadInNotesList: "day ahead in the notes list",
  daysAheadInNotesList: "days ahead in the notes list",
  eventTypesToIncludeInNotesList: "Event types to include in notes list",
  ["calendar.all_day"]: "All-day events, including multi-day events",
  ["calendar.event_link"]: "Events without a meeting link",
  ["calendar.participants"]: "Events with only one participant",
  createNoteFromUpcomingMeeting: "Create a note from an upcoming meeting",
  noUpcomingMeetings: "No upcoming meetings. You can change the time-frame in",
  seeUpcomingMeetings: "See upcoming meetings here with the",
  searchForAnApp: "Search for an app...",
  meetingAppsWatched: "%{num} meeting apps watched",
  automaticMeetingDetectionTitle: "Automatic meeting detection",
  automaticMeetingDetectionDescription: "Superthread detects when a meeting app is using the microphone and notifies you to create a note",
  joinMeetingFromNote: "Join %{provider} meeting (%{time})",
  searchPlaceholderAskAiNotes: "Ask a question about your notes...",
  askAi: "Ask AI",
  transcribeHereInsteadPositive: "Transcribe here instead",
  notesAreBetterWithOurApp: "Notes are better with our app",
  downloadTheMacOSApp: "Download the macOS app",
  toTranscribeMeetings: "to transcribe meetings",
  notifyUpcomingMeetingsTitle: "Notify me of upcoming calendar meetings",
  notifyUpcomingMeetingsDescription: " If a meeting is about to start Superthread will notify you and offer to create a new note.",
  macOSApp: "macOS app",
  requiresMacosAppOne: "Requires the",
  requiresMacosAppTwo: "macOS app.",
  meetingsMenuBarTitle: "Show upcoming calendar meetings next to the menu bar app",
  meetingsMenuBarDescription: "The next meeting on the current day will show next to the Superthread icon in the menu bar.",
  meetingName: "Meeting name",
  meetingTime: "Meeting time",
  searchLanguage: "Search language",
  ["get_started_notes.title"]: "Get started with notes",
  ["get_started_notes.tooltip"]: "Meeting transcription and AI-enhanced note-taking",
  transcriptionNotAvailableOnPlan: "Transcription is not available on this plan. Click to see available plans",
  openLinksInDesktopAppTitle: "Open desktop app when you log in",
  openLinksInDesktopAppDescription: "Automatically open Superthread desktop app when you log in",
  automaticallyStartTranscription: "Automatically start transcription",
  wheneverICreateANote: "Whenever I create a note",
  onlyWhenITakeNotesForMeeting: "Only when I take notes for a meeting",
  learnMore: "Learn more",
  withAnInteractiveVideoTutorial: "with an interactive video tutorial",
  newToNotes: "New to notes?",
  onlyWhenITakeNotesForMeetingSubtitle: "If you create a note from a calendar event up to 5 minutes before the start time, or join a video call from a note",
  instantEmail: "instant email",
  emailDigest: "email digest",
  instantEmailNotifications: "Instant email notifications",
  goToLatest: "Go to latest",
  meetingAndTranscriptionSettings: "Meeting and transcription settings",
  meetingAndTranscriptionSettingsSubtitle: "These settings can only be used in the",
  customiseNotesSettingsOne: "Or customise your",
  customiseNotesSettingsTwo: "notes settings",
  enableSubGroupBy: "Sub-group by",
  boardLimitReached: "The board limit has been reached. You can delete some boards to create more.",
  alphabetical: "Alphabetical",
  chronological: "Chronological",
  numeric: "Numeric",
  role: "Role",
  invitesPending: "Invites pending",
  standardMembers: "Standard members",
  guests: "Guests",
  selected: "Selected",
  bulkActions: "Bulk actions",
  parentCardWasRemoved: "The parent card was removed.",
  cardRemovedFromProject: "The card was removed from the project."
};
var index_default = en;
export {
  index_default as default
};
